module.exports = __webpack_public_path__ + "static/media/gianthead.978b3847.png";